import { TableCell } from "@mui/material";
import React from "react";

function StyledTableCell({ children, className, onClick, sx, ...rest }) {
  return (
    <TableCell
      onClick={onClick}
      className={className}
      sx={{
        padding: "14px 20px",
        fontSize: 14,
        color: "var(--blackColor)",
        borderBottom: "none",
        ".dark-theme &": {
          color: "var(--whiteColor)",
        },
        ...sx,
      }}
      {...rest}
    >
      {children}
    </TableCell>
  );
}

export default StyledTableCell;
